module.exports = __webpack_public_path__ + "static/media/signin.a9c33e3a.svg";